import { lastSearchHistory } from 'shared';

const LAST_SEARCH_KEY = 'free-avia:last-search';
export const lastSearch =
  lastSearchHistory.model.useLastSearchHistory(LAST_SEARCH_KEY);
